<mat-dialog-content class="mat-typography">
    <h3 class="text-left">¡HOLA!</h3>
    <h3>En el <strong>FTyC</strong> los créditos se adaptan al tamaño de tu PyME.</h3>
    <h3>Cuanto más pequeña sea tu empresa las condiciones
        financieras serán más accesibles.</h3>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="boton-rojo-ftyc">Iniciar</button>
</mat-dialog-actions>
